import { render } from "./StandaloneApplicationConfiguration.vue?vue&type=template&id=8a9ae624&ts=true"
import script from "./StandaloneApplicationConfiguration.vue?vue&type=script&lang=ts"
export * from "./StandaloneApplicationConfiguration.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__